export const stringToColour = (name: string) => {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  let colour = '#'
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff
    // Tornar a cor mais clara
    colour += ('00' + Math.min(value + 120, 255).toString(16)).slice(-2)
  }
  return colour
}
